import provider from './config';

export const getLicenseInfo = async (): Promise<any> => {
  try {
    const response = await provider.get('license/');
    return response.data[0];
  } catch (err: any) {
    throw Error("Ocorreu um erro ao tentar buscar as informações de licença");
  }
}